import { allTrackers } from "app/services/track/track";

import type { TrackingServiceDeps } from "./types";

function createFeatureUpgradeTrackingService({ track }: TrackingServiceDeps) {
    function trackWithTableCategory(action: string, event: string) {
        track("upgrade_banner", action, event);
    }

    return {
        trackFeatureAccessRequested(feature = "") {
            trackWithTableCategory("click", `request access/${feature}`);
        },
    };
}

export default createFeatureUpgradeTrackingService({
    track: allTrackers.dispatchTrackEvent.bind(allTrackers),
});
